export default "__VITE_ASSET__q_HZgtKM__"